export const inputCls = "w-full rounded-lg border border-[#D4AF37]/25 bg-black/40 px-3 py-2.5 text-sm text-white placeholder:text-zinc-600 outline-none transition-colors focus:border-[#D4AF37]";

export const PageTitle = ({ title, sub, children }) => (
  <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
    <div>
      <h1 className="font-serif text-2xl font-bold text-white sm:text-3xl">{title}</h1>
      {sub && <p className="mt-1 text-sm text-zinc-500">{sub}</p>}
    </div>
    {children && <div className="flex flex-wrap gap-2">{children}</div>}
  </div>
);

export const Card = ({ title, children, className = "", testid }) => (
  <div className={`rounded-2xl border border-[#D4AF37]/20 bg-[#101117] p-5 sm:p-6 ${className}`} data-testid={testid}>
    {title && <h2 className="mb-4 text-xs font-semibold uppercase tracking-[0.2em] text-[#D4AF37]">{title}</h2>}
    {children}
  </div>
);

export const Field = ({ label, hint, children }) => (
  <label className="block">
    <span className="mb-1.5 block text-xs font-medium uppercase tracking-wider text-zinc-400">{label}</span>
    {children}
    {hint && <span className="mt-1 block text-xs text-zinc-600">{hint}</span>}
  </label>
);

export const Toggle = ({ checked, onChange, testid, label }) => (
  <button type="button" role="switch" aria-checked={checked} onClick={() => onChange(!checked)} data-testid={testid}
    className="flex items-center gap-3 text-sm text-zinc-300">
    <span className={`relative h-6 w-11 shrink-0 rounded-full transition-colors ${checked ? "bg-[#D4AF37]" : "bg-zinc-700"}`}>
      <span className={`absolute left-0 top-0.5 h-5 w-5 rounded-full bg-white transition-transform ${checked ? "translate-x-[22px]" : "translate-x-0.5"}`} />
    </span>
    {label}
  </button>
);

export const ScoreBadge = ({ score, testid, size = "sm" }) => {
  const c = score >= 80 ? "text-emerald-400 border-emerald-400/60" : score >= 50 ? "text-amber-400 border-amber-400/60" : "text-red-400 border-red-400/60";
  const s = size === "lg" ? "h-20 w-20 text-2xl border-4" : "h-10 w-10 text-xs border-2";
  return <span data-testid={testid} className={`grid shrink-0 place-items-center rounded-full font-bold ${s} ${c}`}>{score}</span>;
};

export const Btn = ({ variant = "gold", className = "", ...p }) => (
  <button {...p} className={`${variant === "gold" ? "btn-gold" : variant === "danger" ? "inline-flex items-center gap-2 rounded-full border border-red-500/50 px-4 py-2 text-xs uppercase tracking-wider text-red-400 transition-colors hover:bg-red-500/10" : "btn-outline"} !py-2 disabled:opacity-50 ${className}`} />
);
